<script>
import MaskedInput from "vue-text-mask";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
export default {
  components: {
    MaskedInput,
  },
  props: {
    deliveryUnits: null,
    tableBusy: null,
    oe: null,

    template: null,
    prexc: null,
  },
  data() {
    return {
      fields: [
        {
          key: "du",
          label: "Delivery Unit",
          sortable: true,
          tdClass: "col-md-6 align-middle",
        },
        // {
        //   key: "isExclusive",
        //   label: "Exclusive",
        //   sortable: true,
        //   tdClass: "align-middle",
        // },
        {
          key: "amount",
          sortable: true,
          tdClass: "col-md-3 text-warning",
        },
        {
          key: "actions",
          label: "Actions",
          tdClass: "col-md-1 align-middle text-center",
          thClass: "text-center",
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 25,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "du",
      sortDesc: false,
      currencyMask: createNumberMask({
        prefix: "",
        allowDecimal: true,
      }),
      isExclusive: false,
    };
  },
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    formatCurrency(data) {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "PHP",
      }).format(data);
    },

    deleteItem(row) {
      const id = row.id;

      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("financeTemplate/deleteBudgetItem", row.id)
            .then(() => {
              this.showToast("Item deleted successfully", "success");
              this.$emit("refresh", this.oe);
              this.$emit("updatePrexc", {
                oe: row.financeTemplateObjectOfExpenditureId,
                prexc: this.prexc,
                template: this.template,
              });
            })
            .catch(() => {
              this.showToast("Error deleting item", "error");
            });
        }
      });
    },
    filterTable(row, filter) {
      if (row.account.accountName.toLowerCase().includes(filter)) {
        return true;
      } else {
        return false;
      }
    },
    updateAmount(record) {
      let data = JSON.parse(JSON.stringify(record));
      delete data.deliveryUnit;
      delete data.financeTemplateObjectOfExpenditure;
      data.amount = Number(this.getExactAmt(data.amount));
      this.$store
        .dispatch("financeTemplate/updateTemplateBudgetItem", data)
        .then(() => {
          this.$emit("updatePrexc", {
            oe: record.financeTemplateObjectOfExpenditureId,
            prexc: this.prexc,
            template: this.template,
          });
          this.showToast("Item updated successfully", "success");
        })
        .catch(() => {
          this.showToast(
            "Cannot update budget item amount. Please contact your administrator",
            "error"
          );
        });
    },
    singleToggle(row) {
      // row.item.isExclusive = !row.item.isExclusive;
      // this.$store
      //   .dispatch("financeTemplate/updateIsExclusive", {
      //     ids: [row.item.id],
      //     isExclusive: row.item.isExclusive,
      //   })
      //   .then(() => {
      //     this.showToast("Items updated successfully", "success");
      //   })
      //   .catch(() => {
      //     this.showToast("Error updating items", "error");
      //   });
    },
    toggleSelect() {
      //   var isExclusive;
      //   var ids;
      //   if (this.isExclusive) {
      //     this.deliveryUnits.forEach((item) => {
      //       item.isExclusive = true;
      //     });
      //     isExclusive = true;
      //     ids = this.deliveryUnits.map((item) => item.id);
      //   } else {
      //     this.deliveryUnits.forEach((item) => {
      //       item.isExclusive = false;
      //     });
      //     isExclusive = false;
      //     ids = this.deliveryUnits.map((item) => item.id);
      //   }
      //   this.$store
      //     .dispatch("financeTemplate/updateIsExclusive", {
      //       ids: ids,
      //       isExclusive: isExclusive,
      //     })
      //     .then(() => {
      //       this.showToast("Items updated successfully", "success");
      //     })
      //     .catch(() => {
      //       this.showToast("Error updating items", "error");
      //     });
    },
  },
  computed: {
    rows() {
      return this.deliveryUnits.length;
    },
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <div id="tickets-table_length" class="dataTables_length">
          <label class="d-inline-flex align-items-center">
            Show&nbsp;
            <b-form-select
              class="form-select form-select-sm mx-1"
              v-model="perPage"
              size="sm"
              :options="pageOptions"
            >
            </b-form-select
            >&nbsp;entries
          </label>
        </div>
      </div>
      <!-- Search -->
      <div class="col-sm-12 col-md-6">
        <div id="tickets-table_filter" class="dataTables_filter text-md-end">
          <label class="d-inline-flex align-items-center">
            Search:
            <b-form-input
              v-model="filter"
              type="search"
              placeholder="Search account name..."
              class="form-control form-control-sm ms-2"
            ></b-form-input>
          </label>
        </div>
      </div>
      <!-- End search -->
    </div>
    <div class="custom-table-responsive mb-0">
      <b-table
        :items="deliveryUnits"
        :fields="fields"
        responsive="sm"
        :per-page="perPage"
        :current-page="currentPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :filter="filter"
        :filter-function="filterTable"
        :busy="tableBusy"
        @filtered="onFiltered"
        bordered
        outlined
        striped
        show-empty
        selected-variant="success"
      >
        <template #empty="scope">
          <div class="text-center">{{ scope.emptyText }}</div>
        </template>
        <template #table-busy>
          <div class="d-flex justify-content-center align-items-center">
            <div class="preloader-component me-2">
              <div class="status">
                <div class="spinner-chase w-20px h-20px">
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                </div>
              </div>
            </div>
            <strong>Loading...</strong>
          </div>
        </template>
        <template #head(isExclusive)>
          <div class="form-check form-checkbox-outline form-check-success">
            <input
              class="form-check-input"
              type="checkbox"
              @change="toggleSelect"
              v-model="isExclusive"
            />
            <label class="form-check-label"> Exclusive </label>
          </div>
        </template>
        <template #cell(actions)="row">
          <b-button
            variant="link"
            @click="deleteItem(row.item)"
            class="text-danger font-size-18"
            ><i class="mdi mdi-trash-can-outline"></i
          ></b-button>
        </template>
        <template #cell(du)="row">
          <span>{{ row.item.deliveryUnit.name }}</span>
        </template>
        <template #cell(amount)="row">
          <masked-input
            autocomplete="off"
            type="text"
            v-model="row.item.amount"
            placeholder="Enter Amount..."
            class="form-control w-75 d-inline-block me-3"
            :mask="currencyMask"
          ></masked-input>
          <b-button
            size="sm"
            variant="outline-success"
            @click="updateAmount(row.item)"
            ><i class="bx bx-save align-middle font-size-15"></i
          ></b-button>
        </template>
        <!-- <template #cell(isExclusive)="row">
          <div class="form-check form-checkbox-outline form-check-success">
            <input
              class="form-check-input"
              type="checkbox"
              v-model="row.item.isExclusive"
              @click="singleToggle(row)"
            />
            <span
              :class="{
                'text-mute': !row.item.isExclusives,
                'text-info': row.item.isExclusive,
              }"
            >
              Exclusive
            </span>
          </div>
        </template> -->
      </b-table>
    </div>
    <div class="row">
      <div class="col">
        <div class="dataTables_paginate paging_simple_numbers float-end">
          <ul class="pagination pagination-rounded mb-0">
            <!-- pagination -->
            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
            ></b-pagination>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
